// extracted by css-extract-rspack-plugin
var _1 = "WyjTZf3nIAjl99Jz";
var _2 = "fATUUcYETWomZAxZ";
var _3 = "fATUUcYETWomZAxZ";
var _4 = "ROA474A54iOw7VMI";
var _5 = "gh9VvHFHeoo9T9CI";
var _6 = "gh9VvHFHeoo9T9CI";
var _7 = "lQB0ph1GMCotxWiT";
export { _1 as "label", _2 as "menu-item", _3 as "menuItem", _4 as "name", _5 as "trigger-wrapper", _6 as "triggerWrapper", _7 as "wrapper" }
